export default {
  init() {
    localStorage.setItem("foundHotspots", JSON.stringify([0, 0, 0, 0]));
  },
  setNewHotspot(newHotspot) {
    localStorage.setItem("foundHotspots", JSON.stringify(newHotspot));
  },
  getNewHotspot() {
    return JSON.parse(localStorage.getItem("foundHotspots"));
  },
};
